// UserProfile.tsx
import React, { useState, useEffect } from "react";
import {
  ProfileContainer,
  SectionTitle,
  UserDataContainer,
  DataRow,
  DataLabel,
  DataValue,
} from "./UserProfile.styles";
import { Button } from "devextreme-react";
import { useNavigate } from "react-router-dom";

interface User {
  id: string;
  name: string;
  email: string;
  username: string;
  nomina: string;
}

const UserProfile = () => {
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const storedUserDataString = localStorage.getItem("userData");

      if (storedUserDataString) {
        const storedData = JSON.parse(storedUserDataString);

        if (storedData && storedData.user) {
          const sourceUser = storedData.user;

          const formattedUser: User = {
            id: sourceUser.id,
            name: sourceUser.nombre,
            email: sourceUser.correo,
            username: sourceUser.nomina,
            nomina: sourceUser.nomina,
          };

          setUser(formattedUser);
        } else {
          console.warn(
            "La estructura de 'userData' en localStorage no contiene la propiedad 'user'."
          );
        }
      } else {
        console.warn("No se encontraron datos del usuario en localStorage.");
      }
    } catch (error) {
      console.error("Error al leer o procesar datos de localStorage:", error);
    }
  }, []);

  if (!user) {
    return (
      <ProfileContainer>
        Cargando perfil o no se encontraron datos de sesión...
      </ProfileContainer>
    );
  }

  return (
    <ProfileContainer>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <Button
          icon="chevronleft"
          text="Regresar"
          stylingMode="outlined"
          style={{ borderColor: "blue", color: "blue" }}
          onClick={() => navigate(-1)}
        />
      </div>
      <SectionTitle>Datos del Usuario</SectionTitle>
      <UserDataContainer>
        <DataRow>
          <DataLabel>Nombre:</DataLabel>
          <DataValue>{user.name}</DataValue>
        </DataRow>
        <DataRow>
          <DataLabel>Email:</DataLabel>
          <DataValue>{user.email}</DataValue>
        </DataRow>
        <DataRow>
          <DataLabel>Nomina:</DataLabel>
          <DataValue>{user.username}</DataValue>
        </DataRow>
      </UserDataContainer>
    </ProfileContainer>
  );
};

export default UserProfile;
